interface FilterSidebarProps {
  type: string;
  region: string;
  year: string;
  types: string[];
  regions: string[];
  years: string[];
  resultCount: number;
  onChange: (key: "type" | "region" | "year", value: string) => void;
  onReset: () => void;
}

const FilterGroup = ({
  title,
  options,
  active,
  onSelect,
}: {
  title: string;
  options: string[];
  active: string;
  onSelect: (value: string) => void;
}) => (
  <div className="pb-5 mb-5 border-b border-background-200 last:border-0 last:pb-0 last:mb-0">
    <h3 className="font-heading font-semibold text-sm text-foreground-950 mb-3">{title}</h3>
    <div className="flex flex-wrap gap-2">
      <button
        type="button"
        onClick={() => onSelect("")}
        className={`px-3 py-1.5 rounded-full text-xs font-medium transition-colors cursor-pointer whitespace-nowrap ${
          active === ""
            ? "bg-primary-500 text-background-50"
            : "bg-background-100 text-foreground-700 hover:bg-background-200"
        }`}
      >
        全部
      </button>
      {options.map((option) => (
        <button
          key={option}
          type="button"
          onClick={() => onSelect(option)}
          className={`px-3 py-1.5 rounded-full text-xs font-medium transition-colors cursor-pointer whitespace-nowrap ${
            active === option
              ? "bg-primary-500 text-background-50"
              : "bg-background-100 text-foreground-700 hover:bg-background-200"
          }`}
        >
          {option}
        </button>
      ))}
    </div>
  </div>
);

export default function FilterSidebar({
  type,
  region,
  year,
  types,
  regions,
  years,
  resultCount,
  onChange,
  onReset,
}: FilterSidebarProps) {
  const hasFilter = Boolean(type || region || year);

  return (
    <aside className="w-full lg:w-64 shrink-0">
      <div className="rounded-lg bg-background-50 border border-background-200 p-5 lg:sticky lg:top-24">
        <div className="flex items-center justify-between mb-5">
          <h2 className="font-heading font-bold text-base text-foreground-950 flex items-center gap-1.5">
            <i className="ri-filter-3-line text-primary-500"></i>
            筛选条件
          </h2>
          {hasFilter && (
            <button
              type="button"
              onClick={onReset}
              className="text-xs text-primary-600 hover:text-primary-700 font-medium cursor-pointer whitespace-nowrap"
            >
              重置
            </button>
          )}
        </div>

        <FilterGroup
          title="类型"
          options={types}
          active={type}
          onSelect={(value) => onChange("type", value)}
        />
        <FilterGroup
          title="地区"
          options={regions}
          active={region}
          onSelect={(value) => onChange("region", value)}
        />
        <FilterGroup
          title="年份"
          options={years}
          active={year}
          onSelect={(value) => onChange("year", value)}
        />

        <div className="mt-5 pt-5 border-t border-background-200 text-xs text-foreground-500">
          共找到 <span className="text-primary-600 font-semibold">{resultCount}</span> 部作品
        </div>
      </div>
    </aside>
  );
}